var map = {
	"./config-landing/banners.vue": [
		"T/mg",
		17
	],
	"./config-landing/footer-crud.vue": [
		"s+sq",
		9
	],
	"./config-landing/missions.vue": [
		"z483",
		5
	],
	"./config-landing/organization-structure-details.vue": [
		"6nm2",
		39
	],
	"./config-landing/organization-structures.vue": [
		"s832",
		10
	],
	"./config-landing/sekar-compartments.vue": [
		"5q7s",
		7
	],
	"./config-landing/work-plans.vue": [
		"qLZ8",
		30
	],
	"./dashboard/dashboard.vue": [
		"RMRF",
		20
	],
	"./feedback-suggestions/feedback-suggestions.vue": [
		"Ip3c",
		15
	],
	"./forums-archieve/forums-archieve.vue": [
		"zSx8",
		1
	],
	"./gallery-folders-archieve/gallery-folders-archieve.vue": [
		"XgcV",
		19
	],
	"./gallery-folders-archieve/gallery-photos-archieve.vue": [
		"m5Jl",
		27
	],
	"./gallery-folders/gallery-folders.vue": [
		"XY3m",
		0
	],
	"./gallery-folders/gallery-photos.vue": [
		"PZHt",
		32
	],
	"./master-data/feedback-categories.vue": [
		"Wqjm",
		13
	],
	"./master-data/forum-categories.vue": [
		"kAeQ",
		4
	],
	"./master-data/gallery-categories.vue": [
		"WKND",
		14
	],
	"./master-data/news-categories.vue": [
		"5ko7",
		12
	],
	"./master-data/structural-components.vue": [
		"i9dD",
		36
	],
	"./news-archieve/news-archieve.vue": [
		"/Y9J",
		8
	],
	"./news/news.vue": [
		"J05f",
		2
	],
	"./user-role/permissions.vue": [
		"9sog",
		6
	],
	"./user-role/role-group.vue": [
		"w7kh",
		40
	],
	"./user-role/role.vue": [
		"BEUD",
		16
	],
	"./user-role/users.vue": [
		"z7aj",
		11
	],
	"./voting-archieve/config-voting-options-archieve.vue": [
		"AoKP",
		24
	],
	"./voting-archieve/config-votings-archieve.vue": [
		"Q6CC",
		3
	],
	"./voting-archieve/votings-archieve.vue": [
		"QfyR",
		34
	],
	"./voting/config-voting-options.vue": [
		"mdY8",
		35
	],
	"./voting/config-votings.vue": [
		"2Q7W",
		18
	],
	"./voting/votings.vue": [
		"wCG8",
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ufig";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/modules lazy ^\.\/.*\.vue$
// module id = ufig
// module chunks = 44